import { messageDefaults, Messages } from '../../../../data/messages';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Message } from 'src/app/shared/interfaces';
import {
  MessageCodes,
  MessageTypes,
  TriggerActionTypes,
} from 'src/app/shared/enums';
import { FeatureFlagService } from 'src/app/modules/feature-flags/services/feature-flag/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/enums/feature-flags';
import { ConfigurationService } from 'src/app/modules/configuration/services/configuration/configuration.service';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  public messageData = new Subject<Message | undefined>();
  public triggerData = new Subject<TriggerActionTypes | undefined>();

  private onOkClickedFunction?: () => void;
  private currentPriority = -1;

  constructor(
    private featureFlag: FeatureFlagService,
    private configurationService: ConfigurationService
  ) {
    // Replace default values in messages with configured values
    const messages = Object.values(Messages);
    for (const message of messages) {
      if (message.hyperLink?.includes(messageDefaults.contactUrl)) {
        message.hyperLink = message.hyperLink.replace(
          messageDefaults.contactUrl,
          this.configurationService.config.contactUrl
        );
      } else if (message.hyperLink?.includes(messageDefaults.supportUrl)) {
        message.hyperLink = message.hyperLink.replace(
          messageDefaults.supportUrl,
          this.configurationService.config.supportUrl
        );
      }
    }
  }

  showMessage(id: number, okFn?: () => void): void {
    const message = Messages[id];
    // override home page link for Early Access page
    if (
      this.featureFlag.isFlagEnabled(FeatureFlags.EARLY_ACCESS) &&
      (id === MessageCodes.HTTP_FORBIDDEN || id === MessageCodes.HTTP_NOT_FOUND)
    ) {
      message.hyperLink = '/';
    }
    if (!message) return;
    const priority = this.getMessagePriority(message);
    if (priority <= this.currentPriority) return;
    this.currentPriority = priority;
    if (okFn) {
      this.onOkClickedFunction = okFn;
    }
    this.messageData.next(message);
  }

  private getMessagePriority(message: Message): number {
    if (message.type === MessageTypes.ERROR && message.isFullScreen) return 2;
    if (message.type === MessageTypes.ERROR) return 1;
    return 0;
  }

  onOkClicked(): void {
    this.onOkClickedFunction?.call(this);
  }

  sendTrigger(trigger: TriggerActionTypes): void {
    this.triggerData.next(trigger);
  }

  clearTriggers(): void {
    this.triggerData.next(undefined);
  }

  clearMessages(): void {
    this.currentPriority = -1;
    this.messageData.next(undefined);
  }
}
